export enum SortOptionsKeys {
  Apy = 'apy',
  Volume = 'volume',
  MarketCap = 'marketCap',
  PriceChange = 'priceChange',
}
